import { createSvgComponent } from "../../icon/createSvgComponent";
import ChevronrightDouble from "@core/__generated__/icon/figma/chevronright-double.svg";
export default createSvgComponent(ChevronrightDouble);